import { Box } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router';
import { Redirect, Route, Switch } from 'react-router-dom';

import { RequireReduxData } from '~/components/RequireReduxData';
import { CustomTranslationList } from '~/scenes/AdminModule/components/People/components/ValueLists/CustomTranslations';
import { WorkflowsConfigurationView } from '~/scenes/AdminModule/components/Views/WorkflowsConfigurationView';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { HomePageSettings } from '~/scenes/PortalViews/Views/AdminViews/Common/HomePageSettings';
import { PortalBrandingSettings } from '~/scenes/PortalViews/Views/AdminViews/Common/PortalBrandingSettings';
import { requiredReduxData } from '~/scenes/PortalViews/Views/AdminViews/data';

export const AdminViewsRouter = () => {
  const { path } = useRouteMatch();

  const { t } = useTranslation();

  const renderLoading = (percentage: string) => (
    <LoadingView>
      {t('loadingPortalView')} - {percentage}
    </LoadingView>
  );

  return (
    <Switch>
      <Redirect exact path={path} to={`${path}/people/custom-translations`} />

      <Route path={`${path}/people`}>
        <Switch>
          <Route path={`${path}/people/custom-translations`}>
            <RequireReduxData
              required={requiredReduxData.CustomTranslationList}
              renderLoading={renderLoading}
            >
              <CustomTranslationList />
            </RequireReduxData>
          </Route>
        </Switch>
      </Route>
      <Route path={`${path}/common`}>
        <Switch>
          <Route path={`${path}/common/homepage-settings`}>
            <RequireReduxData
              required={requiredReduxData.HomePageSettings}
              renderLoading={renderLoading}
            >
              <HomePageSettings />
            </RequireReduxData>
          </Route>
          <Route path={`${path}/common/branding-settings`}>
            <RequireReduxData
              required={requiredReduxData.PortalBrandingSettings}
              renderLoading={renderLoading}
            >
              <PortalBrandingSettings />
            </RequireReduxData>
          </Route>
        </Switch>
      </Route>
      <Route path={`${path}/workflow`}>
        <Switch>
          <Route path={`${path}/workflow/workflow`}>
            <Box>Old Workflows</Box>
          </Route>
          <Route path={`${path}/workflow/workflow2`}>
            <RequireReduxData
              required={requiredReduxData.WorkflowsConfigurationView}
              renderLoading={renderLoading}
            >
              <WorkflowsConfigurationView />
            </RequireReduxData>
          </Route>
        </Switch>
      </Route>
    </Switch>
  );
};
